// app/blog/_components/icons.tsx
//
// Centralized SVG icon set used by covers + UI. Server-renderable.

type IconProps = { size?: number; className?: string; strokeWidth?: number };

const base = (sw = 2): React.SVGProps<SVGSVGElement> => ({
  width: 16,
  height: 16,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: sw,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
});

export function GlobeIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z" />
    </svg>
  );
}
export function CrossIcon({ size = 16, strokeWidth = 2.4 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}
export function GavelIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M3 6l9 4 9-4" />
      <path d="M3 6v12l9 4 9-4V6" />
      <path d="M12 22V10" />
    </svg>
  );
}
export function ChartIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  );
}
export function GearIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
    </svg>
  );
}
export function ColumnsIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M3 21h18" />
      <path d="M3 10l9-7 9 7" />
      <path d="M5 21V10" />
      <path d="M19 21V10" />
      <path d="M9 21v-7" />
      <path d="M15 21v-7" />
    </svg>
  );
}
export function CapIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  );
}
export function LightningIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  );
}
export function StarIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <polygon points="12 2 15 8 22 9 17 14 18 21 12 17 6 21 7 14 2 9 9 8" />
    </svg>
  );
}
export function DocIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
    </svg>
  );
}
export function MegaphoneIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M3 11l18-5v12L3 14v-3z" />
      <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>
  );
}
export function ShieldIcon({ size = 16, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  );
}
export function SearchIcon({ size = 20, strokeWidth = 2.2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}
export function BookmarkIcon({ size = 18, strokeWidth = 2, filled = false }: IconProps & { filled?: boolean }) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size} fill={filled ? "currentColor" : "none"}>
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
}
export function CopyIcon({ size = 14, strokeWidth = 2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}
export function XLogoIcon({ size = 14 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2H21l-7.04 8.04L22.5 22h-6.86l-5.32-6.96L4 22H1.244l7.52-8.6L1.5 2h7.02l4.86 6.42L18.244 2z" />
    </svg>
  );
}
export function LinkedInIcon({ size = 14 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.27c-.97 0-1.75-.79-1.75-1.76s.78-1.76 1.75-1.76 1.75.79 1.75 1.76-.78 1.76-1.75 1.76zm13.5 12.27h-3v-5.6c0-1.34-.03-3.06-1.86-3.06-1.86 0-2.14 1.46-2.14 2.97v5.69h-3v-11h2.88v1.5h.04c.4-.76 1.38-1.56 2.84-1.56 3.04 0 3.6 2 3.6 4.59v6.47z" />
    </svg>
  );
}
export function CheckIcon({ size = 14, strokeWidth = 3 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
export function ArrowRightIcon({ size = 22, strokeWidth = 2.2 }: IconProps) {
  return (
    <svg {...base(strokeWidth)} width={size} height={size}>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="13 6 19 12 13 18" />
    </svg>
  );
}

export function getIconByKey(
  key: NonNullable<import("../_data/types").BlogCover["iconKey"]>,
  props?: IconProps
) {
  switch (key) {
    case "globe":      return <GlobeIcon {...props} />;
    case "cross":      return <CrossIcon {...props} />;
    case "gavel":      return <GavelIcon {...props} />;
    case "chart":      return <ChartIcon {...props} />;
    case "gear":       return <GearIcon {...props} />;
    case "columns":    return <ColumnsIcon {...props} />;
    case "cap":        return <CapIcon {...props} />;
    case "lightning":  return <LightningIcon {...props} />;
    case "star":       return <StarIcon {...props} />;
    case "doc":        return <DocIcon {...props} />;
    case "megaphone":  return <MegaphoneIcon {...props} />;
    case "shield":     return <ShieldIcon {...props} />;
  }
}
